module.exports = __webpack_public_path__ + "static/media/near.3285f63.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/near.mp3
// module id = ll+v
// module chunks = 202